import React, { FC, useEffect, useState } from "react";
import { Link, Route, Switch, useLocation, useRouteMatch } from "react-router-dom";

import Header from "@components/Header";
import Objects from "./Objects/Objects";
import Connections from "./Connections/Connections";
import ObjectRoles from "./ObjectRoles/ObjectRoles";
import WebServices from "./WebServices/WebServices";
import Applications from "./Application/Applications";
import MailServerSettings from "./MailServerSettings/MailServerSettings";

import { HeaderTab } from "@components/HeaderTab";
import { HeaderText } from "@components/HeaderText";

import { useFormatMessage } from "@hooks/formatMessage";

import "../../styles/index.scss";
import "./ConfigurationBase.scss";
import { TConfigurationBaseProps } from "./types";
import { ListContainer } from "@components/ListContainer";

const tabs = [
  { path: "connections", renderComponent: props => <Connections {...props} /> },
  { path: "mailserversettings", renderComponent: props => <MailServerSettings {...props} /> },
  { path: "objects", renderComponent: props => <Objects {...props} /> },
  { path: "objectroles", renderComponent: props => <ObjectRoles {...props} /> },
  { path: "webservices", renderComponent: props => <WebServices {...props} /> },
  { path: "applications", renderComponent: props => <Applications {...props} /> },
];

const ConfigurationBase: FC<TConfigurationBaseProps> = props => {
  const { locales, history } = props;

  const [currentTab, setCurrentTab] = useState("");
  const { path, url } = useRouteMatch();
  const formatMessage = useFormatMessage();
  const location = useLocation();
  const state = location.state as Record<string, string>;

  useEffect(() => {
    if (state) {
      setCurrentTab(state.currentTab);
    }
  }, [state]);

  return (
    <ListContainer>
      <Header title="Configuration" locales={locales}>
        {tabs.map(tab => (
          <HeaderTab active={currentTab === tab.path}>
            <Link to={{ pathname: `${url}/${tab.path}`, state: { currentTab: tab.path } }}>
              <HeaderText active={currentTab === tab.path}>
                {formatMessage(`configuration.${tab.path}`)}
              </HeaderText>
            </Link>
          </HeaderTab>
        ))}
      </Header>
      <Switch>
        {tabs.map(tab => (
          <Route path={`${path}/${tab.path}`}>{tab.renderComponent({ location, history })}</Route>
        ))}
      </Switch>
    </ListContainer>
  );
};

export default ConfigurationBase;
